// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"b3f5f6fc","52":"b47410fa","80":"7de56e71","146":"ec799ee9","173":"3509ac5c","231":"c71b62df","353":"850b0ec9","401":"197853a5","454":"ef80f09a","655":"6bc0a138","848":"8e1c4eba","900":"d4ed7046","975":"9dd4fe7d","982":"d9557238","987":"91ec49f5"}[chunkId] + ".chunk.js";
};